import SecurePage from '@/components/Navigation/SecurePage';
import routes, { RouteConfig } from './routes';
import { Route, Routes } from 'react-router';

const createSecureElement = (route: RouteConfig) => {
  return route.page ? (
    <SecurePage
      requireLogin={route.requireLogin}
      allowedRoles={route.allowedRoles}
      showNavigation={route.showNavigation}
      requiredPermissions={route.requiredPermissions}
    >
      {route.page}
    </SecurePage>
  ) : null;
};

const createRoute = (
  route: RouteConfig,
  children?: React.ReactNode,
) => {
  const element = createSecureElement(route);

  if (route.index) {
    return (
      <Route
        key={route.key || route.path}
        index
        path={route.path}
        element={element}
      />
    );
  }

  return (
    <Route
      key={route.key || route.path}
      path={route.path}
      element={element}
    >
      {children}
    </Route>
  );
};

const RoutesList = () => {
  return (
    <Routes>
      {routes.map((route) =>
        createRoute(
          route,
          route.routes?.map((subroute) => createRoute(subroute)),
        ),
      )}
    </Routes>
  );
};

export default RoutesList;
